<div class="books-page">
  <product-page #products
    [mainFilterName]="'книги'"
    [filterName]="'книги'"
    [productType]="'book'"
    [pageName]="'book'"
    [showFilters]="true"
  ></product-page>

</div>
